import * as types from "./actionTypes";

export function setConfigType(type) {
  return { type: types.SET_INTEGRATION_CONFIG_TYPE, payload: { type } };
}
export function addWebhook(payload) {
  return { type: types.ADD_WEBHOOK, payload };
}
export function removeWebhook(payload) {
  return { type: types.REMOVE_WEBHOOK, payload };
}
